<app-ui-main-menu>
  <mat-card class="indications-page">
    <mat-card-header>
      <mat-card-title>Relatório de Contas e Usuários</mat-card-title>
    </mat-card-header>

    <mat-card-content class="page-content">
      <form
        [formGroup]="filters"
        class="filters"
        (ngSubmit)="applySearch()"
        novalidate
      >
        <mat-form-field appearance="outline" class="search-field">
          <mat-label>Pesquise pelo e-mail do usuário</mat-label>
          <input
            matInput
            formControlName="search"
            placeholder="Pesquise pelo e-mail do usuário"
            (keyup.enter)="applySearch()"
          />
        </mat-form-field>

        <div class="searchBtn">
          <button mat-flat-button color="primary" type="submit">
            Pesquisar
          </button>
        </div>
      </form>

      <app-loading *ngIf="loading"></app-loading>

      <ng-container *ngIf="!loading">
        <div *ngIf="dataSource.data.length === 0" class="empty">
          <h3>Nenhum conteúdo disponível</h3>
        </div>

        <div *ngIf="dataSource.data.length > 0" class="table-shell">
          <div class="table-scroll" tabindex="0">
            <table mat-table [dataSource]="dataSource" class="wide-table">
              <ng-container matColumnDef="accountName">
                <th mat-header-cell *matHeaderCellDef>
                  <span class="col-title" matTooltip="Nome da conta (advogado/escritório)">Nome Conta</span>
                </th>
                <td mat-cell *matCellDef="let row">{{ row.account?.name || '-' }}</td>
              </ng-container>

              <ng-container matColumnDef="accountMobile">
                <th mat-header-cell *matHeaderCellDef>
                  <span class="col-title" matTooltip="Telefone principal da conta">Telefone</span>
                </th>
                <td mat-cell *matCellDef="let row">{{ formatPhone(row.account?.mobile) }}</td>
              </ng-container>

              <ng-container matColumnDef="accountEmail">
                <th mat-header-cell *matHeaderCellDef>
                  <span class="col-title" matTooltip="E-mail principal da conta">E-mail Conta</span>
                </th>
                <td mat-cell *matCellDef="let row">{{ row.account?.email || '-' }}</td>
              </ng-container>

              <ng-container matColumnDef="userName">
                <th mat-header-cell *matHeaderCellDef>
                  <span class="col-title" matTooltip="Nome do usuário vinculado">Nome Usuário</span>
                </th>
                <td mat-cell *matCellDef="let row">{{ row.user?.name || '-' }}</td>
              </ng-container>

              <ng-container matColumnDef="userEmail">
                <th mat-header-cell *matHeaderCellDef>
                  <span class="col-title" matTooltip="E-mail do usuário vinculado">E-mail Usuário</span>
                </th>
                <td mat-cell *matCellDef="let row">{{ row.user?.email || '-' }}</td>
              </ng-container>

              <ng-container matColumnDef="status">
                <th mat-header-cell *matHeaderCellDef>
                  <span class="col-title" matTooltip="Status do usuário na conta">Status</span>
                </th>
                <td mat-cell *matCellDef="let row">
                  {{ row.accountUser?.status === 'active' ? 'Ativo' : (row.accountUser?.status === 'pending' ? 'Pendente' : 'Inativo') }}
                </td>
              </ng-container>

              <ng-container matColumnDef="actions">
                <th mat-header-cell *matHeaderCellDef>Ações</th>
                <td mat-cell *matCellDef="let row" class="actions">
                  <button
                    mat-mini-fab
                    color="primary"
                    *ngIf="row.accountUser?.status === 'pending'"
                    matTooltip="Reenviar E-mail de Ativação"
                    (click)="resendActivation(row.user?.id)"
                    [disabled]="resendingUserId === row.user?.id"
                  >
                    <ng-container *ngIf="resendingUserId !== row.user?.id; else resendSpinner">
                      <fa-icon icon="paper-plane"></fa-icon>
                    </ng-container>
                    <ng-template #resendSpinner>
                      <mat-progress-spinner
                        diameter="18"
                        strokeWidth="3"
                        mode="indeterminate"
                        class="spinner-white"
                      ></mat-progress-spinner>
                    </ng-template>
                  </button>
                </td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
            </table>
          </div>

          <mat-paginator
            [length]="total"
            [pageIndex]="pageIndex"
            [pageSize]="pageSize"
            [pageSizeOptions]="[10, 25, 50, 100, 500]"
            (page)="onSearch($event)"
          >
          </mat-paginator>
        </div>
      </ng-container>
    </mat-card-content>
  </mat-card>
</app-ui-main-menu>
